import logo from "@/assets/logo/logo-icon.png";
import { ReactNode } from "react";

type AuthContainerProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

const AuthContainer = ({ title, subtitle, children }: AuthContainerProps) => {
  return (
    <section className="pb-4 pt-[68px] px-8 flex flex-col h-full w-full  justify-center items-center lg:max-w-[850px]">
     <div className="w-full md:w-[450px]">
     <div className="border-[1.5px] rounded-lg border-gray-300 p-1 w-[40px]">
        <img src={logo} className="w-full" alt="Logo" />
      </div>
      <h2 className="text-gray-900 pb-2 text-heading-4 font-semibold mt-3">
        {title}
      </h2>
      {subtitle && (
        <p className="text-gray-500 select-none text-caption-1-large">
          {subtitle}
        </p>
      )}
      {children}
     </div>
    </section>
  );
};

export default AuthContainer;
